import { useState } from "react";
import { toast } from "@/components/feedback/toast";
import { adminFetch } from "@/api";

export interface GroupActionsBarProps {
  groupId: string;
  inviteLinkCount: number;
}

export function GroupActionsBar({
  groupId,
  inviteLinkCount,
}: GroupActionsBarProps) {
  const [busy, setBusy] = useState(false);

  const onRevoke = async () => {
    if (
      !confirm(
        `Revoke all ${inviteLinkCount} invite link${inviteLinkCount === 1 ? "" : "s"} for this group? Existing invites will stop working.`
      )
    ) {
      return;
    }
    setBusy(true);
    try {
      const res = await adminFetch(
        `/api/groups/${groupId}/revoke-invite-links`,
        { method: "POST" }
      );
      if (!res.ok) {
        toast.error("Revoke failed");
        return;
      }
      const data = (await res.json()) as { revokedCount: number };
      toast.success(
        `Revoked · ${data.revokedCount} invite link${data.revokedCount === 1 ? "" : "s"} deleted`
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      {inviteLinkCount > 0 ? (
        <button
          type="button"
          onClick={onRevoke}
          disabled={busy}
          className="inline-flex items-center gap-2 rounded-md border border-fc-warn/40 bg-fc-warn/10 px-3 py-1.5 text-[12.5px] font-semibold text-fc-warn hover:brightness-110 disabled:opacity-60"
        >
          Revoke all invite links
          <span className="rounded border border-fc-warn/40 px-1.5 text-[10px] font-mono">
            {inviteLinkCount}
          </span>
        </button>
      ) : (
        <span className="text-[12px] text-fc-text-dim">
          No active invite links to revoke
        </span>
      )}
    </div>
  );
}
